import { Flex, VStack } from "@chakra-ui/react";
import { MeetingTemplate } from "features/Resources/MeetingTemplate/models";
import { ShowTrigger } from "features/Resources/Shared/Components/Fields/TriggerField";
import { ShowPrebuiltPaths } from "features/Resources/Shared/Components/Fields/PathsField";
import { ShowName } from "features/Resources/Shared/Components/Fields/NameField";
import { ActionTypeTag } from "design-system";
import { ShowRichText } from "components/FormElements/Fields/RichTextAreaField";
import { ShowRecordTarget } from "features/Resources/Shared/Components/Fields/RecordTargetField";

export default function PrebuiltMeetingTemplateDisplay({
  prebuiltMeetingTemplate,
}: {
  prebuiltMeetingTemplate: MeetingTemplate;
}) {
  return (
    <VStack spacing={4} align="stretch" width="100%">
      <Flex w="100%" justify="space-between" align="center" height="40px">
        <ShowName name={prebuiltMeetingTemplate?.name} />
        <ActionTypeTag.Badge actionType="meeting" />
      </Flex>
      <ShowPrebuiltPaths prebuiltPathIds={prebuiltMeetingTemplate?.pathIds} />
      <ShowRecordTarget recordTarget={prebuiltMeetingTemplate?.recipient} label="To" />
      <ShowTrigger label="Send At" trigger={prebuiltMeetingTemplate?.deliverAtTrigger} />
      <ShowRichText label="Meeting" richText={prebuiltMeetingTemplate.bodyDisplay ?? prebuiltMeetingTemplate.body} />
    </VStack>
  );
}
